module.exports = __webpack_public_path__ + "img/1J7.f88c606f.png";